export default function ZapierSettings() {

    var barkZapierCtrl = (function() {

        const $btnSetupZapier = $('#btnSetupZapier');
        const $lnkApp = $('.lnkApp');
        const $btnTryZap = $('.btnTryZap');
        const winfeats = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=980,height=700';
        // const $mdlZapier = $('#mdlZapier');
        // const $frameZap = $('#frameZap');
        const elocat = 'settings:zapier';

        const init = function() {

            $lnkApp.on('click', function(e) {
                var t = $(this);
                if (t.data('type') == 'tools') {
                    $.post('/api/elo/', {
                        c: elocat,
                        n: 'click:tools',
                        i:  t.data('title')
                    });
                }
            });

            $btnTryZap.on('click', function(e) {

                var button = e.target;
                var href = button.getAttribute('data-popup-href');

                $.post('/api/elo/', {
                    c: elocat,
                    n: 'click:try',
                    i:  button.getAttribute('data-app')
                });

                var w = window.open(href, 'zapierModalWindow', winfeats);

                if (w) {
                    if (window.focus) w.focus();
                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    return true;
                }

                return false;

            });

            $btnSetupZapier.on('click', function(e) {

                var button = e.target;
                var href = button.getAttribute('data-popup-href');
                var w = window.open(href, 'zapierModalWindow', winfeats);

                $.post('/api/elo/', {
                    c: elocat,
                    n: 'click:setup',
                });

                if (w) {
                    if (window.focus) w.focus();
                    e.preventDefault();
                    e.stopPropagation();
                } else {
                    return true;
                }

                return false;
            });
        };

        return {
            init: init
        }

    })();

    barkZapierCtrl.init();

}
